/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-18 09:29:26
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { trim } from "lodash";
import { toVisualThousands } from "../utils";
import { labelFont } from "../visualConfig";

export default  ({
  // label,
  list = [],
  color = []
}) => {
  const len = list.length;
  const width = 100 / len;
  const label = ['KOL用户内容条数', '普通用户内容条数'];
  return {
    title: [{
      text: [
        '全年内容条数合计',
        '{sub|（不包括跟贴评论）：}',
      ].join(''),
      left: 10,
      bottom: 10,
      textStyle: {
        rich: {
          sub: {
            fontSize: 14,
          },
        },
      },
    },
    ...list.map((item, index) => ({
      subtext: trim(item.name),
      left: `${width * index + width / 2 - .5}%`,
      top: '10%',
      textAlign: 'center',
      subtextStyle: {
        fontWeight: 'bold',
        fontSize: 20,
        color: index === 3 ? '#df3642' : '#000',
      },
    }))
    ],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color,
    legend: {
      bottom: 10,
      right: 10,
    },
    grid: {
      left: 120,
      right: 0,
      bottom: '3%',
      containLabel: false
    },
    series: list.map((item, index) => {
      return {
        name: item.name,
        type: 'pie',
        // radius: 70,
        label: {
          position: 'inside',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        selectedMode: 'single',
        radius: ['15%', '40%'],
        center: [`${width * index + width / 2}%`, '50%'],
        data: item.list.map((ele, i) => ({
          selected: i === 0,
          name: label[i],
          value: ele,
        })),
      }
    })
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P15/chart.js